import { render, staticRenderFns } from "./SortingIcon.vue?vue&type=template&id=72df907e&"
import script from "./SortingIcon.vue?vue&type=script&lang=js&"
export * from "./SortingIcon.vue?vue&type=script&lang=js&"
import style0 from "./SortingIcon.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports